import { CampaignEdit, Venue } from "interfaces/campaign-edit";

export type CampaignCompensationPayload = {
  id: string;
  venues: Venue[];
  creatorCategories: string[];
  gender: string;
  dietaryRestrictions: string[];
  minRating: number;
  tiers: any[];
};

export const getCampaignVenuesFromDetails = (
  campaign: CampaignEdit,
): Venue[] => {
  return (
    campaign.collabsDetatils
      ?.map((collab) => collab?.venue)
      .filter((venue): venue is Venue => Boolean(venue?.uuid)) ?? []
  );
};

export const buildCampaignCompensationPayload = (
  campaign: CampaignEdit,
  venues: Venue[],
): CampaignCompensationPayload => {
  return {
    id: campaign._id,
    venues,
    creatorCategories: campaign.creatorCategories || [],
    gender: campaign.gender || "",
    dietaryRestrictions: campaign.dietaryRestrictions || [],
    minRating: campaign.minRating,
    tiers: campaign.tiers || [],
  };
};
